import Reflux from 'reflux';

const SingleNodeActions = Reflux.createActions({
  get: { asyncResult: true },
});

export default SingleNodeActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/nodes/SingleNodeActions.js